/**
 * Every string this surface renders, transcribed from the pack verbatim.
 *
 * **The «what was unaffected» sentence is the reason this page exists**, and on
 * an operator surface it says something the subscriber version does not. A
 * subscriber fears a half-taken payment. An operator fears a half-run
 * destructive action, so the paragraph denies the four this console can run:
 * nothing was published, no entitlement was granted, no category, shelf, or plan
 * was deleted, no setting was written.
 *
 * Those are exactly the four actions the console gates behind a confirm step,
 * and the confirm step is the only guard that ships — the audit log is deferred,
 * so the operator has **no record to check afterwards**. That makes the denial
 * load-bearing rather than reassuring, and it is why the sentence enumerates the
 * four rather than saying «nothing changed». If the audit log lands, this
 * paragraph and the confirmation copy change together.
 */
export const copy = {
  /** Tab identification only — this host is `noindex, nofollow` everywhere. */
  documentTitle: 'حدث خلل من جانبنا — وحدة تحكّم شاهدني',

  heading: 'حدث خلل من جانبنا',

  body: 'الخدمة لم تستجب لهذا الطلب. الخلل عندنا لا عندك: لم يُنشر عنوان، ولم يُمنح استحقاق، ولم يُحذف تصنيف ولا رفّ ولا خطّة، ولم يُكتب أي إعداد. ما كان قائماً قبل الطلب لا يزال كما هو.',

  actions: {
    retry: 'أعد المحاولة',
    home: 'عد إلى لوحة التشغيل',
  },
} as const;
